import { createActions } from 'redux-actions';
import { User } from '@models/User';
import { CreateAuthMemberIdParams } from '@apis/AuthMemberIdApi';
import { CheckAuthOtpCodeParams, VerifyAuthOtpCodeParams } from '@apis/AuthOtpCodeApi';
import { CheckAuthPasswordParams, VerifyAuthPasswordParams } from '@apis/AuthPasswordApi';

export type State = {
  serverErrors: object;
  error?: string;
  user?: User | null;
  errors: string[];
};

export type OtpCodeSignInPayload = CheckAuthOtpCodeParams;
export type OtpCodeCheckPayload = CheckAuthOtpCodeParams;
export type OtpCodeVerifyPayload = VerifyAuthOtpCodeParams;
export type PasswordSignInPayload = CheckAuthPasswordParams;
export type PasswordVerifyPayload = VerifyAuthPasswordParams;
export type MemberIdRegisterPayload = CreateAuthMemberIdParams;
export type StateUpdatePayload = Partial<State>;

export const {
  otpCodeSignIn,
  otpCodeCheck,
  otpCodeVerify,
  passwordSignIn,
  passwordVerify,
  memberIdRegister,
  camDxSignIn,
  signInSuccess,
  stateUpdate,
  stateClear,
} = createActions(
  'OTP_CODE_SIGN_IN',
  'OTP_CODE_CHECK',
  'OTP_CODE_VERIFY',
  'PASSWORD_SIGN_IN',
  'PASSWORD_VERIFY',
  'MEMBER_ID_REGISTER',
  'CAM_DX_SIGN_IN',
  'STATE_UPDATE',
  'STATE_CLEAR',
  {
    prefix: 'AUTH_ROUTE',
  },
);
